import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'; // Import translation hook
import './Carousel.css'; // Import the new CSS file

const slides = [
  {
    image: '/Homepage/main_img.jpg',
    descriptionKey: 'carousel.welcome', // Translation key
  },
  {
    image: '/Homepage/eggyolk_pastry.jpg',
    descriptionKey: 'carousel.specialty',
  },
  {
    image: '/Homepage/main_img.jpg',
    descriptionKey: 'carousel.giftBoxes',
  },
  {
    image: '/Homepage/eggyolk_pastry.jpg',
    descriptionKey: 'carousel.freshQuality',
  },
];

function Carousel() {
  const { t } = useTranslation(); // Use translation function
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 3000); // Change image every 3 seconds
    return () => clearInterval(interval); // Cleanup interval
  }, []);

  return (
    <div className="carousel">
      <div
        className="carousel-image"
        style={{
          backgroundImage: `url(${slides[currentIndex].image})`,
        }}
      ></div>
      <div className="carousel-description">
        {t(slides[currentIndex].descriptionKey)} {/* Dynamic translation */}
      </div>
      <div className="carousel-indicators">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`indicator ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)} // Allow manual navigation
          ></span>
        ))}
      </div>
    </div>
  );
}

export default Carousel;